import { Injectable, Inject, EventEmitter } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router } from '@angular/router';
import {AppConfig} from '../../app.config';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';

import { UploadFile, UploadInput, humanizeBytes, UploadOutput, NgUploaderService } from 'ngx-uploader';


@Injectable()
export class UploadService {
    uploadInput: EventEmitter<UploadInput>;
    uploadOutput: EventEmitter<UploadOutput>;
    fileList: FileList;
    upload: NgUploaderService;

    // private uploadUrl = 'http://localhost:3000/upload';

    /**
     * Store all uploads which are "in progress"
     * Show them in the queue component (/queue/:hash)
     */
    private uploads = {};

    /** ngx-uploader demo code { >>> */
    formData: FormData;
    files: UploadFile[];
    humanizeBytes: Function;
    dragOver: boolean;
    /** <<< } ngx-uploader demo code */


    constructor(
        private router: Router,
        private appConfig:AppConfig
    ) {
        /** ngx-uploader demo code { >>> */
        this.files = []; // local uploading files array
        this.humanizeBytes = humanizeBytes;
        /** <<< } ngx-uploader demo code */

        this.upload = new NgUploaderService();
        this.uploadInput = new EventEmitter<UploadInput>();
        this.upload.initInputEvents(this.uploadInput);

        this.upload.serviceEvents.subscribe((event:any) => {
            console.log(event);
        });
    }

    onUploadOutput(output: UploadOutput): void {
        /** ngx-uploader demo code { >>> */
        // console.log(output); // lets output to see what's going on in the console

        if (output.type === 'allAddedToQueue') { // when all files added in queue
            // uncomment this if you want to auto upload files when added
            const event: UploadInput = {
                type: 'uploadAll',
                url: this.appConfig.apiUrl+'/api/user/audio/temp/upload',
                method: 'POST',
                data: { hash: this.generateHash() },
                // concurrency: 1
            };

            this.uploadInput.emit(event);

        } else if (output.type === 'addedToQueue') {
            this.files.push(output.file); // add file to array when added
        } else if (output.type === 'uploading') {
            // update current data in files array for uploading file
            const index = this.files.findIndex(file => file.id === output.file.id);
            this.files[index] = output.file;
        } else if (output.type === 'removed') {
            // remove file from array when removed
            this.files = this.files.filter((file: UploadFile) => file !== output.file);
        } else if (output.type === 'dragOver') { // drag over event
            this.dragOver = true;
        } else if (output.type === 'dragOut') { // drag out event
            this.dragOver = false;
        } else if (output.type === 'drop') { // on drop event
            this.dragOver = false;
        /** <<< } ngx-uploader demo code */

        } else if (output.type === "start") {
            /**
             * Here I would like to navigate to /queue/:hash to enter some details
             * about the uploaded content, while it's uploading
             * this.router.navigateByUrl(`/queue/${hash}`);
             */
        }else if (output.type==='done'){
          console.log('output.file.response.name >>'+output.file.response.name);
          return output.file.response.name;
        }
    }


    /**
     * Generate a different hash for each batch of uploads to keep track of batches;
     * Used for queue navigation (/queue/:hash)
     *
     * Also, needed server side to be able to continue uploading photos to the
     * same album, while you edit some info on the queue page
     * @param length
     * @param chars
     */
    generateHash(length: number = 6, chars: string = 'abcdefghijklmnopqrstuvwxyz0123456789') {
        let hash = '';
        for (let i = length; i > 0; i--) {
            hash += chars[Math.floor(Math.random() * chars.length)];
        }
        return hash;
    }

}



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/shared/services/upload.service.ts